import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AgencyTypeModel } from 'src/app/Model/AgencyType.model';
import { AggregatorModel } from 'src/app/Model/Aggregator.model';
import { ResponseData } from 'src/app/Model/Base/Response';
import { ContactTypeModel } from 'src/app/Model/ContactType.model';
import { ContactsModel } from 'src/app/Model/Contacts.model';
import { DocumentTypeModel } from 'src/app/Model/DocumentType.model';
import { LegalRepresentativeModel } from 'src/app/Model/LegalRepresentative.model';
import { PartnersModel } from 'src/app/Model/Partners.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { RequestIdentificationModel } from 'src/app/Model/RequestIdentification.model';
import { RequestLocationModel } from 'src/app/Model/RequestLocation.model';
import { RequestStatusProcess } from 'src/app/Model/RequestStatusProcess';
import { RolesArdModel } from 'src/app/Model/RolesArd.model';
import { SignatureUsersModel } from 'src/app/Model/SignatureUsers.model';
import { UpdateStatusProcessModel } from 'src/app/Model/UpdateStatusProcess.model';
import { VRequestStatusProcessModel } from 'src/app/Model/VRequestStatusProcess.Model';
import { BaseService } from '../Base/BaseService';
import { SessionStorageService } from "../sessionStorageService/session-storage.service";
import { AuthService } from '../Interceptor/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RequestService extends BaseService {
  constructor(public http: HttpClient, public lsService : SessionStorageService, authService: AuthService) { 
    super(http, lsService,authService);
    this.Component = "RequestService";
  }
  public async postRequest(state: RequestModel) {
    let response: ResponseData;
    await this.PostData(state, "Request", "Post").then((res) => {
      response = res;
    });
    return response;
  }
  public async getRequestLocationOld(id: number) {
    let request: RequestLocationModel;
    await this.PostData(id, "Request", "GetRequestLocationOld").then((res) => {
      if (res.head.status != 'False') {
        request = JSON.parse(res.body.response);
        let request2: RequestLocationModel = Object.create(RequestLocationModel.prototype);
        Object.assign(request2, request);
        request=request2;
      }
    });
    return request;
  }
  public async postOverview(state: RequestModel) {
    let response: ResponseData;
    await this.PostData(state, "Request", "PostOverview").then(async (res) => {
      if (res.head.status != 'False')
        response = res;
    });
    return response;
  }
  public async postStatusCorrection(state: UpdateStatusProcessModel) {
    let response: ResponseData;
    await this.PostData(state, "Request", "PostStatusCorrection").then((res) => {
      response = res;
    });
    return response;
  }
  public async validIATA(request: RequestModel) {
    let response: ResponseData;
    await this.PostData(request, "Request", "ValidIATA").then((res) => {
      response = res;
    });
    return response;
  }
  public async postIdentification(state: RequestIdentificationModel) {
    let response: ResponseData;
    await this.PostData(state, "Request", "PostIdentification").then((res) => {
      response = res;
    });
    return response;
  }
  public async postLocation(state: RequestLocationModel) {
    let response: ResponseData;
    await this.PostData(state, "Request", "PostLocation").then((res) => {
      response = res;
    });
    return response;
  }
  public async postLegalRepresentative(state: LegalRepresentativeModel) {
    let response: ResponseData;
    await this.PostData(state, "Request", "PostLegalRepresentative").then((res) => {
      response = res;
    });
    return response;
  }
  public async postContact(state: ContactsModel) {
    let response: ResponseData;
    await this.PostData(state, "Request", "PostContact").then((res) => {
      response = res;
    });
    return response;
  }
  public async deleteContact(state: ContactsModel) {
    let response: ResponseData;
    await this.PostData(state, "Request", "DeleteContact").then((res) => {
      response = res;
    });
    return response;
  }
  public async updateCrmPartners(state: RequestModel){
    let response: ResponseData;
    await this.PostData(state, "Request", "updateCrmPartners").then((res) => {
      response = res;
    });
    return response;
  }

  public async postPartner(state: PartnersModel) {
    let response: ResponseData;
    await this.PostData(state, "Request", "PostPartner").then((res) => {
      response = res;
    });
    return response;
  }
  public async deletePartner(state: PartnersModel) {
    let response: ResponseData;
    await this.PostData(state, "Request", "DeletePartner").then((res) => {
      response = res;
    });
    return response;
  }
  public async postSignatureUser(state: SignatureUsersModel) {
    let response: ResponseData;
    await this.PostData(state, "Request", "PostSignatureUser").then((res) => {
      response = res;
    });
    return response;
  }
  public async deleteSignatureUser(state: SignatureUsersModel) {
    let response: ResponseData;
    await this.PostData(state, "Request", "DeleteSignatureUser").then((res) => {
      response = res;
    });
    return response;
  }
  public async postRequestLegalComent(request: RequestModel) {
    let response: ResponseData;
    await this.PostData(request, "Request", "PostRequestLegalComent").then((res) => {
      response = res;
    });
    return response;
  }
  public async getRequest() {
    let request: RequestModel[];
    await this.PostData("", "Request", "Get").then((res) => {
      if (res.head.status != 'False') {
        request = JSON.parse(res.body.response);
      }
    });
    return request;
  }
  public async getRequestById(data) {
    let request: RequestModel;
    if(data != null){
      await this.PostData(data, "Request", "GetId").then((res) => {
        if (res.head.status != 'False') {
          request = JSON.parse(res.body.response);
          let request2: RequestModel = Object.create(RequestModel.prototype);
          Object.assign(request2, request);
          request=request2;
        }
      });
    }   
    return request;
  }
  public async getRequestByCode(data) {
    let request: RequestModel;
    await this.PostData(data, "Request", "GetCode").then((res) => {
      if (res.head.status != 'False') {
        request = JSON.parse(res.body.response);
        let request2: RequestModel = Object.create(RequestModel.prototype);
        Object.assign(request2, request);
        request=request2;
      }
    });
    return request;
  }
  public async getRequestStatusProcess(id: number) {
    let status: RequestStatusProcess[];
    await this.PostData(id, "Request", "RequestStatusProcess").then((res) => {
      if (res.head.status != 'False') {
        status = JSON.parse(res.body.response);
      }
    });
    return status;
  }
  public async getRequestStatuses(id: number) {
    let statuses: VRequestStatusProcessModel[];
    await this.PostData(id, "Request", "GetStatuses").then((res) => {
      if (res.head.status != 'False') {
        statuses = JSON.parse(res.body.response);
      }
    });
    return statuses;
  }
  public async getAgencyTypes() {
    let CountryCurrency: AgencyTypeModel[];
    await this.PostData("", "Request", "GetAgencyTypes").then((res) => {
      if (res.head.status != 'False') {
        CountryCurrency = JSON.parse(res.body.response);
      }
    });
    return CountryCurrency;
  }
  public async getAggregators() {
    let aggregators: AggregatorModel[];
    await this.PostData("", "Request", "GetAggregators").then((res) => {
      if (res.head.status) {
        aggregators = JSON.parse(res.body.response);
      }
    });
    return aggregators;
  }
  public async getDocumentTypes() {
    let aggregators: DocumentTypeModel[];
    await this.PostData("", "Request", "GetDocumentTypes").then((res) => {
      if (res.head.status) {
        aggregators = JSON.parse(res.body.response);
      }
    });
    return aggregators;
  }
  public async getContactTypes() {
    let aggregators: ContactTypeModel[];
    await this.PostData("", "Request", "GetContactTypes").then((res) => {
      if (res.head.status) {
        aggregators = JSON.parse(res.body.response);
      }
    });
    return aggregators;
  }
  public async getRolesARD() {
    let aggregators: RolesArdModel[];
    await this.PostData("", "Request", "GetRolesARD").then((res) => {
      if (res.head.status) {
        aggregators = JSON.parse(res.body.response);
      }
    });
    return aggregators;
  }

  public async crmRequestValidation(data){
    let Document: boolean;
    await this.PostData(data,"Request","CrmRequestValidation").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  }

  public async rejectLegal(req: RequestIdentificationModel) {
    let response: ResponseData;
    await this.PostData(req, "Request", "RejectLegal").then((res) => {
      response = res;
    });
    return response;
  }

  public async postLegalRepresentativeCheckboxRepsonse(legalRep: LegalRepresentativeModel){
    let response: ResponseData;
    await this.PostData(legalRep, "Request", "PostLegalRepresentativeCheckboxRepsonse").then((res) => {
      if(res.head.status != 'False')
        response = res;
    });
    return response;
  }

}
